<template>
  <div id="app">    
    <router-view />
    <VueAnnouncer />
   <logout></logout>
  </div>
</template>

<script>
import axios from 'axios';
import Logout from '@/components/ThemeMegazine/pages/partialsCommon/Logout';
import { AsgardeoSPAClient } from "@asgardeo/auth-spa";
import {LOCAL_HOST,WSO_CLIENTID,WSO_BASEURL} from '@/constants/general_constants';

const auth = AsgardeoSPAClient.getInstance();
auth.initialize({
     signInRedirectURL: LOCAL_HOST+"/ssowsocallback",
     signOutRedirectURL: LOCAL_HOST+"/ssowsologout",
     clientID: WSO_CLIENTID,
     baseUrl: WSO_BASEURL,
     scope: [ "profile" ]
});
export default{
   data(){
      return{
        redirect_path:''
      };        
    },
    components:{  
      Logout
    },      
    created:function(){
      if((!localStorage.id_company && !localStorage.id_session) || this.$route.params.token ){  /*Login condition check*/
         
        if(this.$route.name=='Login'  && !this.$route.query.code){           
          if(this.$route.params.company_id===undefined){
            this.$router.push({path:'/login'})
          }
          else if(this.$route.params.token===undefined){
            this.$router.push({path:'/companyLogin/'+this.$route.params.company_id})
          }
          
          /*else if(this.$route.params.user===undefined){
            w //login with ps
             console.log('with passcode')
             this.validateLogin('onlypsw',this.$route.params.company_id,this.$route.params.code)
          }*/
          else{
            //login with username and psw
            //console.log('tkn-'); return false;
             this.validateLogin('token',this.$route.params.company_id,this.$route.params.token)
          }           
        }
        else if(this.$route.name=='CompanyLogin'){
          if(this.$route.query.login_hint === undefined || this.$route.query.login_hint == '' || this.$route.query.login_hint === 'undefined'){
            this.$router.push({path:'/CompanyLogin/'+this.$route.params.company_id+'/'+this.$route.params.file_name})
          } else {
            // for Azure SSO with login_hint param in url
            this.$router.push({path:'/CompanyLogin/'+this.$route.params.company_id+'/'+this.$route.params.file_name+'?login_hint='+this.$route.query.login_hint}) 
          }
        }
        else if(this.$route.name=='CompanyChooser'){
          this.$router.push({path:'/companyLogin/'+this.$route.params.company_id+'/'+this.$route.params.file_name})
        }else if(this.$route.name=="directContentDetail" ){        
         // if(this.$store.state.directContentFlag===0){
           // this.$store.state.directContentFlag=1;
            this.$router.push({path:this.$route.fullPath});
         // }
        }
        else if(this.$route.name=='ssocallback' ){ 
            this.$router.push({path:this.$route.fullPath});
        } 
        else if(this.$route.name=='ssoazurecallback' ){ 
            this.$router.push({path:this.$route.fullPath});
        }
        else if(this.$route.name=='ssowsocallback' ){
            this.$router.push({path:this.$route.fullPath});
        }
        else if(this.$route.name=='ssowsologout' ){ 
            this.$router.push({path:this.$route.fullPath});
        }
        else if(!this.$route.query.code){
          if(this.$route.name=='Content'){
            this.$router.push({path:'/content_detail/'+this.$route.params.id})
          }else{
            this.$router.push({path:'/login'})
          }
        }
        
      }else{
          this.$store.dispatch('getTheme');
          this.$store.dispatch('getLanguageTerms');
          this.$store.dispatch('getThemeLogic');
          this.$store.dispatch('getCompanyDataInfo');
          
          document.documentElement.setAttribute("lang", localStorage.lang_abbrevation);
          //this.$router.push({path:'/'});
      }
    },
    methods: {
      validateLogin: function(type,company_id,token){
        //console.log('tkn-'+token)
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            if(type=='token'){
              //formData.append('company_id', company_id)
              formData.append('id_eap', company_id)
              formData.append('token', token)
              formData.append('origref', document.referrer)
            }
           //setTimeout(function(){
             axios.post(this.$store.state.apiUrl+'/login',formData,config)
            .then(response => {
              var tmp_response=response.data;
                response = response.data[0];
                //alert('tt'+tmp_response.message);
                if(response === undefined || response.length == 0 ){
                    this.err='! Invalid Credential / No Access'
                    alert("Invalid Credential / No Access");
                }
                else{
                    this.$store.state.companyData=response
                    this.$store.state.companyData['custom_text_1'] = response.custom_text_1
                    this.$store.state.companyData['custom_text_2'] = response.custom_text_2
                    this.$store.state.companyData['custom_text_3'] = response.custom_text_3
                    this.$store.state.companyData['custom_text_4'] = response.custom_text_4
                    this.$store.state.companyData['custom_text_5'] = response.custom_text_5
                    this.$store.state.companyData['id_company'] = response.id_company
                    this.$store.state.companyData['id_design'] = response.id_design
                    this.$store.state.companyData['id_eap'] = response.id_eap
                    this.$store.state.companyData['filename'] = response.filename
                    this.$store.state.companyData['id_service'] = response.id_service
                    this.$store.state.companyData['name_company'] = response.name_company
                    this.$store.state.companyData['encrypt_key'] = response.encrypt_key
                    this.$store.state.companyData['name_css'] = response.name_css
                    this.$store.state.companyData['id_language'] = response.language_id_default.substr(3,3)
                    this.$store.state.companyData['id_country'] = response.language_id_default.substr(0,3)
                    this.$store.state.companyData['id_session'] = response.id_session
                    this.$store.state.companyData['login_user'] = response.logname
                    this.$store.state.companyDataInfo.company_logo=response.company_logo
                    localStorage.company_logo=response.company_logo                   
                    localStorage.id_company = response.id_company;
                    localStorage.id_design = response.id_design;
                    localStorage.id_eap = response.id_eap;
                    localStorage.id_service = response.id_service;
                    localStorage.id_service_link = response.id_service_link;               

                    localStorage.id_language = response.language_id_default.substr(3,3);                    
                    localStorage.id_country = response.language_id_default.substr(0,3);
                    localStorage.custom_text_1 = response.custom_text_1;
                    localStorage.encrypt_key = response.encrypt_key;
                    localStorage.name_company = response.name_company;
                    localStorage.custom_text_2 = response.custom_text_2;
                    localStorage.custom_text_3 = response.custom_text_3;
                    localStorage.custom_text_4 = response.custom_text_4;
                    localStorage.custom_text_5 = response.custom_text_5;
                    localStorage.id_session = response.id_session;
                    localStorage.login_user = response.logname;
                    localStorage.filename = response.filename;
                    

                    if(response.language_id_default=="" && !response.is_sso_enabled){                  
                      this.$router.push({path:'/languageChooser'})     
                      return false                 
                    }
                  
                    this.$store.dispatch('getTheme')
                    this.$store.dispatch('getLanguageTerms');
                    this.$store.dispatch('getThemeLogic');
                    this.$store.dispatch('getCompanyDataInfo');
                    if(response.is_sso_enabled){
                      localStorage.sso_redirect = this.$route.params.redirect;
                      localStorage.sso_language = response.language_id_default;
                      this.call_sso();
                    } 
                    else if(this.$route.params.redirect===undefined){
                      this.$router.push({path:'/'})
                    } 
                    else {
                      axios.get(this.$store.state.apiUrl+'/decode_redirect',{
                            params:{
                                encodeUrl:this.$route.params.redirect          
                            }
                        })
                        .then(response => {              
                              var redirect_to = response.data;
                              this.$router.push({path:redirect_to});
                        })
                        .catch(() => {
                          this.$router.push({path:'/'})
                        });
                    }
                }
                
            })
            .catch(() => {
                this.company_data = [];
                alert("Invalid Credential / No Access");
                this.err='Try after sometime'
            });


            //},200);
           // event.preventDefault();
            
        },
        async call_sso(){
          var login_hint = this.$route.query.login_hint;
          if(!login_hint){
              login_hint = '';
          }
          await auth.signIn({login_hint: login_hint});
          this.$router.push({path:'/ssowsocallback'});
        }       

    }
}; 

</script>
<style>
#app {
  /*font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;*/
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

a.linkinfo span {
   display: none;
}
a.linkinfo:hover span, a.linkinfo:focus span, a.linkinfo:active span {
    display: block;
    position: absolute;
    top: 1.2em;
    left: 1em;
    width: 22em;
    border: 1px solid #000;
    background-color: #F4F4F4;
    color: #000;
    text-align: center;
}
a.linkinfo{
  position: relative;
  z-index: 25px;
}


/* added for testing
.btn-primary {
   
    background: rgb(19, 85, 207) !important;
    color: #fff;
} */

.horizontal_ul_center_aligned {
    text-align: center;
    width: 90%;
}
.horizontal_ul_center_aligned li {
    display: inline-flex;
    margin-left: 9px !important;
    padding-right: 8px !important;
}

@media screen and (max-width: 480px) {
  a.linkinfo:hover span, a.linkinfo:focus span, a.linkinfo:active span {
    top: -4em;
    width: 8em;
    transform: translateX(-10%);
    font-size: 9px;
  }
}
</style>